import {
  CE_HEIC_BRANDS,
  CE_HEIC_EXTENSIONS,
  CE_HEIC_JPEG_QUALITY,
} from '~/ui/constants/communityEngagement';

import { splitFileName } from './formatCeDocument';

export const isHeicFileName = (fileName: string): boolean =>
  CE_HEIC_EXTENSIONS.includes(splitFileName(fileName).extension.slice(1).toLowerCase());

export const toUploadFileName = (fileName: string): string =>
  isHeicFileName(fileName) ? `${splitFileName(fileName).name}.jpg` : fileName;

const readHeader = (file: File): Promise<string> =>
  new Promise(resolve => {
    const reader = new FileReader();
    reader.onload = () => {
      const { result } = reader;
      resolve(
        result instanceof ArrayBuffer
          ? Array.from(new Uint8Array(result), byte => String.fromCharCode(byte)).join('')
          : '',
      );
    };
    reader.onerror = () => resolve('');
    reader.readAsArrayBuffer(file.slice(0, 12));
  });

export const hasHeicSignature = async (file: File): Promise<boolean> => {
  const header = await readHeader(file);
  return header.slice(4, 8) === 'ftyp' && CE_HEIC_BRANDS.includes(header.slice(8, 12));
};

const convertHeicToJpeg = async (file: File): Promise<File> => {
  try {
    const { heicTo } = await import('heic-to/csp');
    const jpeg = await heicTo({ blob: file, type: 'image/jpeg', quality: CE_HEIC_JPEG_QUALITY });
    return new File([jpeg], toUploadFileName(file.name), { type: 'image/jpeg' });
  } catch {
    throw new Error("Couldn't convert the photo to JPEG");
  }
};

export default convertHeicToJpeg;
